(function () {
  "use strict";
  var CONFIG = {
      productUrl: "/products/kiddospace-reusable-water-spongeballs",
      exitUrl: "/pages/6-reasons-why-water-sponge-balls",
      logoUrl:
        "https://thekiddospacestore.com/cdn/shop/files/New_logo_118x_2x_8455129b-5f9c-4cc5-8d47-906d4b391699_118x.png?v=1746770607",
      topBarText: "Stell das richtige Set für deine Familie zusammen!",
      trustLine: "3,500+ happy families on 90-day guarantee",
      fixedKit: {
        name: "Your Summer Splash Setup Is Unlocked",
        tagline:
          "Best for supervised outdoor splash play on flat grass or a soft outdoor mat.",
        price: "\xA329.99",
        comparePrice: "\xA349.99",
        savings: "You save \xA320 today",
        variantId: "REPLACE_WITH_VARIANT_ID_1",
        image:
          "https://thekiddospacestore.co.uk/cdn/shop/files/1-Web-Images--Splash-Pad_900x900_4c00c416-6fc4-4c78-830c-d7ef336b8c72_720x720.jpg",
        perks: [
          "Dein Wasserschlacht-Setup wird überprüft",
          "10 extra Wasserschwammbälle werden kostenlos hinzugefügt",
          "2 Netzbeutel werden kostenlos hinzugefügt",
          "90-Tage-Geld-zurück-Garantie",
        ],
        reviews: [
          {
            text: "My grandkids absolutely love these! No more balloon mess on the lawn.",
            author: "Sandra M.",
            status: "verified buyer \u2714",
          },
          {
            text: "Best purchase this summer. My kids fight over who gets to refill them!",
            author: "Jennifer R.",
            status: "verified buyer \u2714",
          },
          {
            text: "Used these at my grandson's birthday, 15 kids going wild for 3 hours. Zero cleanup!",
            author: "Robert K.",
            status: "verified buyer \u2714",
          },
        ],
      },
      loadingItems: [
        "Dein Wasserschlacht-Setup wird überprüft",
        "10 extra Wasserschwammbälle werden kostenlos hinzugefügt",
        "2 Netzbeutel werden kostenlos hinzugefügt",
        "90-Tage-Geld-zurück-Garantie",
      ],
      steps: [
        {
          id: "who",
          eyebrow: "Question 1 of 5",
          question: "Für wen kaufst du das?",
          subtext: "This helps us confirm the right fit for your family.",
          options: [
            {
              value: "My grandkids",
              icon: "\uD83D\uDC75",
              label: "Meine Enkelkinder",
              desc: "Meine Enkelkinder",
            },
            {
              value: "My own kids",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Meine Kinder",
              desc: "Meine Kinder",
            },
            {
              value: "For a party or event",
              icon: "\uD83C\uDF89",
              label: "Für eine Party oder ein Event",
              desc: "Für eine Party oder ein Event",
            },
            {
              value: "It's a gift",
              icon: "\uD83C\uDF81",
              label: "Als Geschenk",
              desc: "Als Geschenk",
            },
          ],
        },
        {
          id: "count",
          eyebrow: "Question 2 of 5",
          question: "Wie viele Kinder spielen normalerweise gleichzeitig?",
          subtext: "Count everyone who might join in.",
          options: [
            {
              value: "1-2",
              icon: "👦",
              label: "1–2",
            },
            {
              value: "3-4",
              icon: "👧👦",
              label: "3–4",
            },
            {
              value: "5-6",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "5–6",
            },
            {
              value: "7+",
              icon: "\uD83C\uDF8A",
              label: "7+",
            },
          ],
        },
        {
          id: "surface",
          eyebrow: "Question 3 of 5",
          question: "Welche Altersgruppen werden hauptsächlich mitspielen?",
          subtext: "The surface affects how well it stays in place.",
          options: [
            {
              value: "1-4",
              icon: "\uD83E\uDDF8",
              label: "1–4",
            },
            {
              value: "5-8",
              icon: "\uD83D\uDCA6",
              label: "5–8",
            },
            {
              value: "9-12",
              icon: "\uD83C\uDFC3",
              label: "9–12",
            },
            {
              value: "Mixed ages",
              icon: "\uD83C\uDF08",
              label: "Gemischte Altersgruppen",
              desc: "Help me decide",
            },
          ],
        },
        {
          id: "hose",
          eyebrow: "Question 4 of 5",
          question: "Wo werden sie sie am meisten benutzen?",
          subtext:
            "The Splash Pad connects directly to a standard garden hose.",
          options: [
            {
              value: "Garden",
              icon: "\uD83C\uDFE1",
              label: "Garten",
            },
            {
              value: "Pool",
              icon: "\uD83C\uDFCA",
              label: "Pool",
            },
            {
              value: "Beach",
              icon: "\uD83C\uDFD6\uFE0F",
              label: "Strand",
            },
            {
              value: "A bit of everything",
              icon: "\uD83C\uDF0D",
              label: "Ein bisschen von allem",
            },
          ],
        },
        {
          id: "priority",
          eyebrow: "Question 5 of 5",
          question: "Was ist dir am wichtigsten?",
          subtext: "Pick the one that fits best.",
          options: [
            {
              value: "No balloon waste to clean up",
              icon: "\uD83E\uDDF9",
              label: "Kein Ballonmüll zum Aufräumen",
            },
            {
              value: "Refills in seconds",
              icon: "\uD83D\uDCA7",
              label: "Schnell nachfüllbar",
            },
            {
              value: "Enough for the whole group",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Genug für die ganze Gruppe",
            },
            {
              value: "Easy to store",
              icon: "\uD83D\uDC5C",
              label: "Einfach zu verstauen",
            },
            {
              value: "Good value for parties",
              icon: "\uD83C\uDFF7\uFE0F",
              label: "Gutes Preis-Leistungs-Verhältnis für Partys",
            },
          ],
        },
        {
          id: "alternative",
          eyebrow: "Question 6 of 6",
          question: "Was ist dir lieber:",
          subtext: "Pick the one that fits best.",
          options: [
            {
              value: "Just enough",
              icon: "\uD83D\uDC66",
              label: "Gerade genug",
              desc: "Gerade genug",
            },
            {
              value: "A little extra",
              icon: "\u2795",
              label: "Ein bisschen mehr",
              desc: "Ein bisschen mehr",
            },
            {
              value: "Cousins and friends",
              icon: "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
              label: "Genug für Cousins und Freunde",
              desc: "Genug für Cousins und Freunde",
            },
            {
              value: "Party-ready",
              icon: "\uD83C\uDF89",
              label: "Partybereit",
              desc: "Partybereit",
            },
          ],
        },
      ],
    },
    state = { screen: "intro", currentStep: 0, answers: {} };
  function el(id) {
    return document.getElementById(id);
  }
  var stars = "\u2605\u2605\u2605\u2605\u2605";
  function renderIntro() {
    var pBar = el("quiz-progress-wrap");
    pBar && (pBar.style.display = "none");
    var stage = el("quiz-stage");
    stage &&
      ((stage.innerHTML =
        '<div class="quiz-intro"><div class="quiz-intro-badge"><span class="quiz-intro-dot"></span> Dauert nur 1 Minute</div><h1 class="quiz-intro-headline">Finden Sie das perfekte Wasserschlacht-Set für Ihre Familie!</h1><p class="quiz-intro-sub">Beantworte 6 kurze Fragen und erhalte dein persönliches Wasserschwammball-Set – <strong>plus 10 extra Wasserschwammbälle gratis dazu!</strong></p><div class="quiz-intro-features"><div class="quiz-intro-feature"><span class="quiz-intro-fi">\uD83C\uDF89</span> No more picking up balloon pieces</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u26A1</span> Refills in 5 seconds by themselves</div><div class="quiz-intro-feature"><span class="quiz-intro-fi">\u2B50</span> 3,500+ five-star reviews from families</div></div><button class="quiz-btn quiz-intro-btn" id="quiz-start-btn" type="button">Mein ideales Set finden<span class="quiz-btn-arrow">\u2192</span></button><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
      el("quiz-start-btn").addEventListener("click", function () {
        ((state.screen = "quiz"),
          pBar && (pBar.style.display = ""),
          renderStep(0));
      }));
  }
  function renderProgress(idx) {
    var total = CONFIG.steps.length,
      pct = Math.round((idx / total) * 100),
      wrap = el("quiz-progress-wrap");
    wrap &&
      (wrap.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Dein Set wird zusammengestellt</span><span class="quiz-progress-count">' +
        idx +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:' +
        pct +
        '%"></div></div></div>');
  }
  function optionCard(opt, stepId) {
    var sel = state.answers[stepId] === opt.value;
    return (
      '<button class="quiz-option' +
      (sel ? " selected" : "") +
      '" data-step="' +
      stepId +
      '" data-value="' +
      opt.value +
      '" type="button" aria-pressed="' +
      sel +
      '"><span class="quiz-option-icon">' +
      opt.icon +
      '</span><span class="quiz-option-body"><span class="quiz-option-label">' +
      opt.label +
      '</span><span class="quiz-option-desc">' +
      opt.desc +
      "</span></span></button>"
    );
  }
  function renderStep(idx) {
    var step = CONFIG.steps[idx],
      hasAnswer = !!state.answers[step.id],
      isLast = idx === CONFIG.steps.length - 1,
      stage = el("quiz-stage");
    if (stage) {
      ((stage.innerHTML =
        '<div class="quiz-step"><button class="quiz-back" id="quiz-back-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Zurück</button><p class="quiz-eyebrow">' +
        step.eyebrow +
        '</p><h2 class="quiz-question">' +
        step.question +
        '</h2><p class="quiz-subtext">' +
        step.subtext +
        '</p><div class="quiz-options">' +
        step.options
          .map(function (o) {
            return optionCard(o, step.id);
          })
          .join("") +
        '</div><div class="quiz-btn-wrap"><button class="quiz-btn" id="quiz-next-btn" type="button"' +
        (hasAnswer ? "" : " disabled") +
        ">" +
        (isLast ? "Meine Empfehlung ansehen" : "Weiter") +
        ' <span class="quiz-btn-arrow">\u2192</span></button></div><div class="quiz-trust"><span class="quiz-trust-stars">' +
        stars +
        "</span><span>" +
        CONFIG.trustLine +
        "</span></div></div>"),
        stage.querySelectorAll(".quiz-option").forEach(function (btn) {
          btn.addEventListener("click", function () {
            var stepId = btn.getAttribute("data-step"),
              val = btn.getAttribute("data-value");
            ((state.answers[stepId] = val),
              stage
                .querySelectorAll('.quiz-option[data-step="' + stepId + '"]')
                .forEach(function (b) {
                  var on = b.getAttribute("data-value") === val;
                  (b.classList.toggle("selected", on),
                    b.setAttribute("aria-pressed", on));
                }));
            var nb2 = el("quiz-next-btn");
            nb2 && (nb2.disabled = !1);
          });
        }));
      var nb = el("quiz-next-btn");
      nb && nb.addEventListener("click", advance);
      var bb = el("quiz-back-btn");
      (bb && bb.addEventListener("click", goBack), renderProgress(idx));
    }
  }
  function renderLoading() {
    var pBar = el("quiz-progress-wrap"),
      total = CONFIG.steps.length;
    pBar &&
      (pBar.innerHTML =
        '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Dein empfohlenes Set wird zusammengestellt</span><span class="quiz-progress-count">' +
        total +
        " / " +
        total +
        '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
    var stage = el("quiz-stage");
    if (stage) {
      var itemsHtml = CONFIG.loadingItems
        .map(function (text, i) {
          return (
            '<div class="loading-item" id="load-item-' +
            i +
            '"><div class="loading-check" id="load-check-' +
            i +
            '"></div><span>' +
            text +
            "</span></div>"
          );
        })
        .join("");
      stage.innerHTML =
        '<div class="quiz-loading" id="quiz-loading-wrap"><div class="loading-spinner" id="loading-spinner"></div><h2 class="loading-title">Mein empfohlenes Set ansehen \u2026</h2><p class="loading-sub" id="loading-sub">Wird anhand deiner Antworten personalisiert</p><div class="loading-checklist">' +
        itemsHtml +
        '</div><div id="loading-cta" style="display:none;"><p class="loading-cta-sub">Wir haben das perfekte Wasserschlacht-Set basierend auf deinen Antworten gefunden.</p><a class="kit-ready-btn" id="kit-ready-btn" href="#"><span class="kit-ready-btn-badge">40% OFF</span><span class="kit-ready-btn-text">Mein empfohlenes Set ansehen \u2192</span></a><div class="quiz-btn-wrap" style="margin-top:14px"><button class="quiz-btn-text" id="kit-retake-btn" type="button"><span class="quiz-back-arrow">\u2190</span> Quiz wiederholen</button></div></div></div>';
      var delays = [0, 1400, 2800, 4200];
      CONFIG.loadingItems.forEach(function (_, i) {
        (setTimeout(function () {
          var item = el("load-item-" + i);
          item && item.classList.add("active");
        }, delays[i]),
          setTimeout(function () {
            var item = el("load-item-" + i),
              check = el("load-check-" + i);
            item &&
              check &&
              (item.classList.remove("active"),
              item.classList.add("done"),
              (check.textContent = "\u2713"));
          }, delays[i] + 1e3));
      });
      var lastDone = delays[delays.length - 1] + 1e3;
      setTimeout(function () {
        var kit = CONFIG.fixedKit,
          url = CONFIG.productUrl;
        kit.variantId &&
          kit.variantId.indexOf("REPLACE_") !== 0 &&
          (url += "?variant=" + kit.variantId);
        var spinner = el("loading-spinner");
        spinner && (spinner.style.display = "none");
        var sub = el("loading-sub");
        sub && (sub.style.display = "none");
        var ctaBtn = el("kit-ready-btn");
        ctaBtn && ctaBtn.setAttribute("href", url);
        var cta = el("loading-cta");
        cta && (cta.style.display = "");
        var rt = el("kit-retake-btn");
        rt &&
          rt.addEventListener("click", function () {
            ((state.screen = "intro"),
              (state.currentStep = 0),
              (state.answers = {}),
              renderIntro());
          });
        var pBar2 = el("quiz-progress-wrap");
        pBar2 &&
          (pBar2.innerHTML =
            '<div class="quiz-progress-inner"><div class="quiz-progress-header"><span class="quiz-progress-label">Dein Set ist fertig!</span><span class="quiz-progress-count">' +
            total +
            " / " +
            total +
            '</span></div><div class="quiz-progress-bar"><div class="quiz-progress-fill" style="width:100%"></div></div></div>');
      }, lastDone);
    }
  }
  function advance() {
    var step = CONFIG.steps[state.currentStep];
    state.answers[step.id] &&
      (state.currentStep >= CONFIG.steps.length - 1
        ? renderLoading()
        : (state.currentStep++,
          renderStep(state.currentStep),
          window.scrollTo({ top: 0, behavior: "smooth" })));
  }
  function goBack() {
    if (state.currentStep <= 0) {
      ((state.screen = "intro"), (state.currentStep = 0), renderIntro());
      return;
    }
    (state.currentStep--,
      renderStep(state.currentStep),
      window.scrollTo({ top: 0, behavior: "smooth" }));
  }
  function init() {
    var root = el("quiz-root");
    root &&
      ((root.innerHTML =
        '<div id="quiz-wrapper"><div class="quiz-topbar"><span class="quiz-topbar-time">&lt;1 Minute</span><span class="quiz-topbar-text">' +
        CONFIG.topBarText +
        '</span></div><header class="quiz-header"><img class="quiz-logo" src="' +
        CONFIG.logoUrl +
        '" alt="KiddoSpace"></header><div id="quiz-progress-wrap" style="display:none"></div><main id="quiz-stage" class="quiz-stage" aria-live="polite"></main></div>'),
      renderIntro());
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
//# sourceMappingURL=/s/files/1/0760/0662/1462/files/Splash_Pad_Quiz.js.map?v=1780486916